import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.values";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

//
//
//
//
//
//
//
//
//
//
//
//
//
var NoveltyDecoration = function NoveltyDecoration() {
  return import(
  /* webpackChunkName: "product-experiment", webpackMode: "eager" */
  '~/components/atoms/Product/Decorations/NoveltyDecoration.vue');
};

var SchoolCharityDecoration = function SchoolCharityDecoration() {
  return import(
  /* webpackChunkName: "product-experiment", webpackMode: "eager" */
  '~/components/atoms/Product/Decorations/SchoolCharityDecoration.vue');
};

var FreeDeliveryDecoration = function FreeDeliveryDecoration() {
  return import(
  /* webpackChunkName: "product-experiment", webpackMode: "eager" */
  '~/components/atoms/Product/Decorations/FreeDeliveryDecoration.vue');
};

var StickerDecoration = function StickerDecoration() {
  return import(
  /* webpackChunkName: "product-experiment", webpackMode: "eager" */
  '~/components/atoms/Product/Decorations/StickerDecoration.vue');
};

export default {
  components: {
    NoveltyDecoration: NoveltyDecoration,
    SchoolCharityDecoration: SchoolCharityDecoration,
    FreeDeliveryDecoration: FreeDeliveryDecoration,
    StickerDecoration: StickerDecoration
  },
  props: {
    isNew: {
      type: Boolean,
      default: false
    },
    isSchool: {
      type: Boolean,
      default: false
    },
    deliveryPromotion: {
      type: Object,
      default: null
    },
    trendSticker: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    decorations: function decorations() {
      var hasDeliveryPromotion = this.deliveryPromotion.alt && this.deliveryPromotion.alt.trim();

      var _ref = this.trendSticker ? Object.values(this.trendSticker) : [],
          _ref2 = _slicedToArray(_ref, 1),
          trend = _ref2[0];

      var decorations = [];

      if (hasDeliveryPromotion) {
        decorations.push({
          tag: 'free-delivery-decoration',
          props: {
            label: this.deliveryPromotion.alt
          }
        });
      } else if (this.isNew) {
        decorations.push({
          tag: 'novelty-decoration',
          props: {}
        });
      }

      if (this.isSchool) {
        decorations.push({
          tag: 'school-charity-decoration',
          props: {}
        });
      } else if (trend) {
        decorations.push({
          tag: 'sticker-decoration',
          props: {
            trend: trend
          }
        });
      }

      return decorations;
    }
  }
};